var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 28,
    viewBox: "0 0 9 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#909ca8",
    d: "M.695 2.07l4.904 4.864-4.904 4.864 1.51 1.495 6.424-6.359L2.204.576z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToRight);
export default __webpack_public_path__ + "static/media/to_right.8835bf2ce298ae781467a195ccdab2b7.svg";
export { ForwardRef as ReactComponent };